<template lang="pug">
#player-betslip-modal.modal.fade.modal-room
  .modal-dialog.modal-lg.modal-dialog-centered.modal-dialog-scrollable
    .modal-content(v-if="item")
      .player-betslip-header
        .close(data-dismiss='modal')
          i.far.fa-times
        .player-icon
          img(src='/images/tournament/user-icon.svg')
        .player-id {{ item.member_id }}
        .d-flex.justify-content-center.mt-2
          .player-info
            .d-flex.justify-content-center
              template(v-if="[1,2,3].includes(item.ranking)")
                img.trophy-icon(:src="'/images/tournament/trophy' + item.ranking + '.svg'")
              template(v-else)
                .icon
                  i.fas.fa-trophy
              .ml-2
                .title {{ $t("ui.place") }}
                template(v-if="item.ranking")
                  .text {{ item.ranking ? item.ranking : '-' }}
          .player-info
            .d-flex.justify-content-center
              .icon
                i.fas.fa-sack-dollar
              .ml-2
                .title {{ $t("ui.current_point") }}
                .text {{ item.prize ? $numeral(item.prize).format("0,0.00") : '-' }}
      .text-white.text-right.px-3.py-1 {{ $t("ui.room_id") }}: {{ item.room_id }}
      .modal-body(v-if="item.room_status != 3")
        template(v-if="item.record && item.record.bet_list.length > 0")
          .player-betslip(v-for="rec in item.record.bet_list")
            .date.text-dkblue {{ $dayjs(rec.created_on).format("MM/DD/YYYY hh:mm:ss A") }}
            .bettype {{ sports[rec.sports_type] }} - {{ $tc("m.BT_" + rec.bet_type, 1) }}
            .d-flex.justify-content-between
              .odds
                .d-flex
                  template(v-if="['HDP','HDPH'].includes(rec.bet_type)")
                    .text-dark(v-if="rec.home_away === 1") {{ getTeamName("home", rec) }}
                    .text-dark(v-else) {{ getTeamName("away", rec) }}
                  template(v-else)
                    .text-dark(v-if="rec.home_away === 1") {{ $t('ui.over') }}
                    .text-dark(v-else) {{ $t('ui.under') }}
                  span.ml-2 {{ rec.ball }}
                  span.text-red.mx-1 @
                  | {{ rec.odds_display }}
              .stake {{ $numeral(rec.bet_member).format("0,0") }}
            .match-info
              .match-team {{ getTeamName("home", rec) }}
              .match-team {{ getTeamName("away", rec) }}
              span.text-dkblue.ml-1 {{ getLeagueName(rec) }}
            .d-flex.justify-content-between
              .id.text-orange {{ $t("ui.id") }}: {{ rec.bet_id }}
              template(v-if="rec.wl_status")
                .status.text-uppercase(v-if="rec.wl != null" :class="{ 'text-dkgreen' : rec.wl > 0, 'text-danger' : rec.wl < 0 }") {{ $t('ui.' + rec.wl_status.toLowerCase().replace(" ", "_")) }} ({{ $numeral(rec.wl).format("0,0.00") }})
              template(v-else)
                .status.text-dkgreen.text-uppercase(v-if="rec.bet_status") {{ $t('ui.' + rec.bet_status.toLowerCase()) }}
        template(v-else)
          .player-betslip.d-flex.align-items-center.justify-content-center
            span {{ $t('message.no_information_available') }}
      .modal-body(v-else)
        template(v-if="betResultList == 'undefined' || betResultList.length <= 0")
          .room-ranking-wrapper.pb-3
            .user-betlist.d-flex.align-items-center.justify-content-center.m-0
              template(v-if="loading.getBetResultList")
                i.fad.fa-spinner-third.fa-spin
              template(v-else)
                .empty.text-center
                  b {{ $t('message.no_information_available') }}
                  //- template(v-else)
        template(v-for="(item, index) in betResultList")
          .room-ranking-wrapper.pb-1
            .user-betlist.m-0
              .d-flex.justify-content-between
                .id.text-orange {{ $t("ui.ref_no") }}: {{ item.bet_id }}
                .status {{ parseFloat(item.winlose) != 0 ? (parseFloat(item.winlose) < 0 ? $t("ui.lost") : $t("ui.won")) : $t("ui.draw") }} ({{ item.score }})
              .odds
                | {{ item.full_half }} - {{ item.goal }}
                span.text-red.mx-1 @
                | {{ item.odds_display }}
              .match-info
                .text-dkblue {{ item.league_name }}
                | {{ item.home_team_name }} -vs- {{ item.away_team_name }}
              .date.text-dkblue {{ $dayjs(item.bet_time).format("MM/DD/YYYY hh:mm:ss A") }}
              .d-flex.result
                .text-center.flex-grow-1.result-item
                  .title {{ $t("ui.stake") }}
                  .amount {{ $numeral(item.bet_member).format("0,0") }}
                .text-center.flex-grow-1.result-item
                  .title {{ $t("ui.winlose") }}
                  .amount(:class="{ 'text-danger': parseFloat(item.winlose) < 0 }") {{ $numeral(item.winlose).format("0,0") }}
                .text-center.flex-grow-1.result-item
                  .title {{ $t("ui.points") }}
                  .amount(:class="{ 'text-danger': parseFloat(item.payout) < 0 }") {{ $numeral(item.payout).format("0,0") }}
</template>

<script>
import config from "@/config";
import errors from "@/errors";
import { EventBus } from "@/library/_event-bus.js";
import service from "@/views/tournament/library/_xhr.js";

export default {
  props: {},
  data() {
    return {
      item: null,
      betResultList: [],
      loading: {
        getBetResultList: false,
      }
    };
  },
  computed: {
    sports() {
      return this.$store.state.layout.sports;
    },
    language() {
      return this.$store.getters.language;
    },
  },
  destroyed() {
    EventBus.$off("TN_PLAYER_BETSLIP", this.showRecord);
  },
  mounted() {
    EventBus.$on("TN_PLAYER_BETSLIP", this.showRecord);
  },
  methods: {
    showRecord(e) {
      this.item = null;
      this.item = e;
      var id = this.item.room_id;
      if (id) {
        this.getBetResultList();
      }
      $("#player-betslip-modal").modal("show");
    },
    getLeagueName(e) {
      var name = e["name_" + this.language];
      if (name == null || name == "" || !name) {
        name = e.league_name;
      }
      return name;
    },
    getTeamName(p, e) {
      var name = e[p + "_name_" + this.language];
      if (name == null || name == "" || !name) {
        name = e[p + "_team_name"];
      }
      return name;
    },
    getBetResultList() {
      var e = this.item.room_id;
      if (e == undefined) {
        return;
      }

      var json = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        room_id: e,
        page_number: 1,
        page_size: 100,
        target: this.item.id,
      };

      var feedback = {
        success: false,
        status: errors.session.invalidSession,
      };

      this.loading.getBetResultList = true;
      service.betResult(config.tournamentUrl().betresultlist, json).then(
        (result) => {
          this.loading.getBetResultList = false;
          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == true) {
              this.betResultList = result.data.value;
            } else {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        (err) => {
          console.log(err);
          this.loading.getBetResultList = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    }
  },
};
</script>
